import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
//   Avatar,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Helmet } from "react-helmet";
import FaceIcon from "@mui/icons-material/Face";

import SecurityIcon from "@mui/icons-material/Security";
import CookieIcon from "@mui/icons-material/Cookie";
import StorageIcon from "@mui/icons-material/Storage";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import ContactMailIcon from "@mui/icons-material/ContactMail";

// import logo from "../images/Flavrapogi-Logo.png";  

const PrivacyPolicy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const sectionCard = {
    borderRadius: 5,
    p: { xs: 3, md: 4 },
    height: "100%",
    background:
      "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(245,250,255,0.9))",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255,255,255,0.3)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    transition: "0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 14px 34px rgba(0,0,0,0.14)",
    },
  };

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Flavrapogi</title>

        <meta
          name="description"
          content="Read the Privacy Policy of Flavrapogi and understand how we collect, use, and protect your information."
        />
      </Helmet>

      <Container
        maxWidth="100vw"
        sx={{
          minHeight: "100vh",
          py: 6,
          background: `
            linear-gradient(
              135deg,
              #0f172a 0%,
              #1e293b 20%,
              #134e4a 55%,
              #0f766e 100%
            )
          `,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            textAlign: "center",
            color: "white",
            mb: 6,
            mt: 3,
          }}
        >
          {/* <Avatar
            src={logo}
            sx={{
              width: isMobile ? 85 : 110,
              height: isMobile ? 85 : 110,
              mx: "auto",
              mb: 2,
              boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
            }}
          /> */}

          <Typography
            variant={isMobile ? "h4" : "h3"}
            sx={{
              fontWeight: 800,
              mb: 1,
              letterSpacing: 1,
            }}
          >
            Privacy Policy
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "rgba(255,255,255,0.85)",
            }}
          >
            Last updated on April 1, 2025
          </Typography>
        </Box>

        {/* Main Wrapper */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1500px",
            }}
          >
            {/* Intro Section */}
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 5 },
                mb: 4,
                borderRadius: 6,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.08))",
                backdropFilter: "blur(16px)",
                border: "1px solid rgba(255,255,255,0.15)",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                gap={2}
                mb={3}
                flexWrap="wrap"
              >
                <SecurityIcon
                  sx={{
                    color: "#5eead4",
                    fontSize: 40,
                  }}
                />

                <Typography
                  variant="h4"
                  sx={{
                    color: "white",
                    fontWeight: 700,
                  }}
                >
                  Your Privacy Matters
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{
                  color: "rgba(255,255,255,0.88)",
                  lineHeight: 2,
                  fontSize: "1rem",
                }}
              >
                This privacy policy sets out how FLAVR APOGI HEALTHCARE AND
                INDUSTRIAL CATERING SERVICES PRIVATE LIMITED uses and protects
                any information that you give when you visit our website and/or
                agree to purchase from us.
                <br />
                <br />
                We are committed to ensuring that your privacy is protected.
                Should we ask you to provide certain information by which you
                can be identified when using this website, you can be assured
                that it will only be used in accordance with this privacy
                statement.
                <br />
                <br />
                We may update this policy from time to time by revising this
                page. Please check this page periodically to stay informed of
                any changes.
              </Typography>
            </Paper>

            {/* Policy Sections */}
            <Grid container spacing={4}>
              {/* Information We Collect */}
              <Grid item xs={12} md={6}>
                <Paper sx={sectionCard}>
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <StorageIcon
                      sx={{
                        color: "#2563eb",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Information We Collect
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography sx={{ lineHeight: 2 }}>
                    • Name
                    <br />
                    • Contact information including email address
                    <br />
                    • Demographic information such as postcode, preferences and
                    interests, if required
                    <br />• Other information relevant to customer surveys
                    and/or offers
                  </Typography>
                </Paper>
              </Grid>

              {/* What We Do */}
              <Grid item xs={12} md={6}>
                <Paper sx={sectionCard}>
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <PrivacyTipIcon
                      sx={{
                        color: "#0f766e",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      How We Use Information
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography sx={{ lineHeight: 2 }}>
                    • Internal record keeping
                    <br />
                    • Improve our products and services
                    <br />
                    • Send promotional emails and offers
                    <br />
                    • Conduct market research
                    <br />• Customize the website according to your interests
                  </Typography>
                </Paper>
              </Grid>

              {/* Cookies */}
              <Grid item xs={12}>
                <Paper sx={sectionCard}>
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <CookieIcon
                      sx={{
                        color: "#ea580c",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Cookies Policy
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography sx={{ lineHeight: 2 }}>
                    A cookie is a small file placed on your device to improve
                    your browsing experience. Cookies allow web applications to
                    respond to you as an individual by gathering and remembering
                    information about your preferences.
                    <br />
                    <br />
                    We use traffic log cookies to identify which pages are being
                    used. This helps us analyze webpage traffic and improve our
                    website performance.
                    <br />
                    <br />
                    You can choose to accept or decline cookies through your
                    browser settings.
                  </Typography>
                </Paper>
              </Grid>

              {/* face dataand biometric */}
              <Grid item xs={12}>
                <Paper sx={sectionCard}>
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <FaceIcon
                      sx={{
                        color: "#ea580c",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Face Data & Biometric Information Policy
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography sx={{ lineHeight: 2 }}>
                    Our application may collect and process user face photos
                    solely for identity verification, meal access
                    authentication, fraud prevention, and account security
                    purposes.
                    <br />
                    <strong>What Face Data We Collect</strong>
                    <br />
                    The app collects:
                    <br />
                    <ul>
                      <li>
                        User-uploaded face photographs during registration or
                        verification.
                      </li>
                      <li>
                        Facial image data required for identity matching and
                        authentication.
                      </li>
                    </ul>
                    <br />
                    The app does not collect or store biometric templates, 3D
                    face maps, Face ID data, or any health-related facial
                    analysis information.
                    <br />
                    <strong>Why We Collect Face Data</strong>
                    <br />
                    Face data is used exclusively for:
                    <ul>
                      <li>User identity verification</li>
                      <li>Preventing duplicate or fraudulent accounts</li>
                      <li>Meal access authentication</li>
                      <li>
                        Improving account security and preventing unauthorized
                        access
                      </li>
                    </ul>
                    Face data is never used for advertising, marketing,
                    profiling, or tracking purposes.
                    <br />
                    <br />
                    <strong>Face Data Storage and Retention</strong>
                    <br />
                    Face images are securely stored on our protected servers for
                    account verification and authentication purposes only.
                    <br />
                    <br />
                    Face data is retained only while the user account remains
                    active or until verification services are required. If a
                    user deletes their account or requests deletion, associated
                    face data is permanently deleted within 30 days.
                    <br />
                    <br />
                    We do not retain face data indefinitely.
                    <br />
                    <br />
                    <strong>Sharing of Face Data</strong>
                    <br />
                    We do not sell, rent, or share face data with advertisers or
                    data brokers.
                    <br />
                    <br />
                    Face data may only be shared with trusted service providers
                    that help us operate authentication or secure cloud storage
                    services. These providers are contractually obligated to
                    protect user data and may not use face data for any other
                    purpose.
                    <br />
                    <br />
                    <strong>Third-Party Storage Practices</strong>
                    <br />
                    If third-party infrastructure providers are used for secure
                    storage or processing, they may temporarily store encrypted
                    face data solely for operational purposes.
                    <br />
                    <br />
                    These providers follow industry-standard security and
                    privacy practices and do not use the data independently.
                    <br />
                    <br />
                    No third party is permitted to retain face data longer than
                    necessary to provide the requested service.
                    <br />
                    <br />
                    <strong>User Control and Deletion</strong>
                    <br />
                    Users may request deletion of their face data and account
                    information at any time by contacting support or deleting
                    their account through the app.
                    <br />
                    <br />
                    Upon request, face data is permanently removed from our
                    systems within 30 days.
                    <br />
                    <br />
                    <strong>Security</strong>
                    <br />
                    We implement reasonable administrative, technical, and
                    physical safeguards to protect face data against
                    unauthorized access, disclosure, or misuse.
                  </Typography>
                </Paper>
              </Grid>

              {/* Personal Info */}
              <Grid item xs={12}>
                <Paper sx={sectionCard}>
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <SecurityIcon
                      sx={{
                        color: "#7c3aed",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Controlling Your Personal Information
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Typography sx={{ lineHeight: 2 }}>
                    You may choose to restrict the collection or use of your
                    personal information by selecting options that indicate you
                    do not want your information used for direct marketing
                    purposes.
                    <br />
                    <br />
                    If you have previously agreed to us using your personal
                    information for marketing, you may change your mind at any
                    time by emailing us at:
                    <br />
                    <strong>flavrapogi@gmail.com</strong>
                    <br />
                    <br />
                    We will never sell, distribute, or lease your personal
                    information to third parties unless required by law or with
                    your permission.
                  </Typography>
                </Paper>
              </Grid>

              {/* Contact */}
              <Grid item xs={12}>
                <Paper
                  sx={{
                    ...sectionCard,
                    background:
                      "linear-gradient(135deg, #0f172a, #1e3a8a, #0f766e)",
                    color: "white",
                  }}
                >
                  <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <ContactMailIcon
                      sx={{
                        color: "#5eead4",
                        fontSize: 36,
                      }}
                    />

                    <Typography variant="h5" fontWeight={700}>
                      Contact Information
                    </Typography>
                  </Box>

                  <Divider
                    sx={{
                      mb: 3,
                      borderColor: "rgba(255,255,255,0.2)",
                    }}
                  />

                  <Typography sx={{ lineHeight: 2 }}>
                    Plot No 239, 2nd Floor, Rudra Vihar, PO - Sisupalgarh,
                    <br />
                    Bhubaneswar, Khordha, Odisha - 751002
                    <br />
                    <br />
                    <strong>Phone:</strong> 9692783839 / 9840110545
                    <br />
                    <strong>Email:</strong> info@flavrapogi.com
                    <br />
                    <strong>Website:</strong> www.flavrapogi.com
                    <br />
                    <br />
                    If you believe that any information we are holding on you is
                    incorrect or incomplete, please write to or email us as soon
                    as possible. We will promptly correct any information found
                    to be incorrect.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
